/** Юридический дисклеймер — только на странице /alerts, не в message с API */
export const NOTIFICATIONS_DISCLAIMER =
    "Внимание: анализ сформирован автоматической системой на основе ответов пациента в опросе. Решение о лечении и необходимости срочной помощи принимает только лечащий врач.";
